import type { DownloadVerification as Verification } from './api';
import { useNamespaceCopy } from '@/i18n/ns';
import { entrySurfaceCopy } from '@/i18n/ns/entry-surfaces';

export function DownloadVerification({ verification }: { verification?: Verification }) {
  const copy = useNamespaceCopy(entrySurfaceCopy);
  if (!verification) return null;
  return (
    <details className="desktop-download-verification">
      <summary>{copy.verify}</summary>
      <p>{copy.checksumHelp}</p>
      <p>
        <a href={verification.manifestUrl} target="_blank" rel="noreferrer">
          {copy.signedChecksums}
        </a>{' '}
        ·{' '}
        <a href={verification.signatureUrl} target="_blank" rel="noreferrer">
          {copy.signature}
        </a>{' '}
        ·{' '}
        <a href={verification.publicKeyUrl} target="_blank" rel="noreferrer">
          {copy.publicKey}
        </a>
      </p>
      <p>
        {copy.fingerprint} <code>{verification.keyFingerprint}</code>
      </p>
    </details>
  );
}
